import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrencyConfig } from '@/src/types/currency'
import { DOMAIN_CURRENCY_MAP } from '@/src/constants/domainCurrencyMap'
import { getCookie, setCookie } from '@/src/utils/browser'
import { encodingValue } from '@/src/utils/currency/formatCurrency'

const COOKIE_NAME = 'utm_currency'

function getDomainCurrency(): CurrencyConfig {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost'
    return DOMAIN_CURRENCY_MAP[hostname] || DOMAIN_CURRENCY_MAP['localhost']
}

export interface CurrencyState {
    selected: string
}

const getInitialCurrency = (): string => {
    if (typeof window === 'undefined') return getDomainCurrency().currency
    const cookieCurrency = getCookie(COOKIE_NAME)
    if (cookieCurrency) return cookieCurrency.split('|')[0]
    return getDomainCurrency().currency
}

const initialState: CurrencyState = {
    selected: getInitialCurrency()
}

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrency: (state, action: PayloadAction<{ code: string; symbol: string }>) => {
            state.selected = action.payload.code
            setCookie(COOKIE_NAME, action.payload.code + '|' + encodingValue(action.payload.symbol), 365 * 10)
        }
    }
})

// Selectors
export const getSelectedCurrency = (state: { currency: CurrencyState }) => state.currency.selected

export const { setCurrency } = currencySlice.actions
export default currencySlice.reducer
